import React from "react"

const AnalyticalConstituents = ( { constituents, energy_title, calories } ) => {
    const acHTML = constituents && constituents.map((item, i) => {
      return (
        <li key={i}>
          <span> { item.title } </span>
          <span> { item.value } %</span>
        </li>
      )
    })
  
    if (!acHTML || !acHTML.length) return null
  
    return (
      <ul className="product--analytical-constituents">
        { acHTML }
        <li>
            <span>{ energy_title }</span>
            <span>{ calories }</span>
        </li>
      </ul>
    )
}

export default AnalyticalConstituents